import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@material-ui/core/IconButton';
import classnames from 'classnames';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    colorPrimary: {},
    variantSquare: {
      border: `1px solid ${colorSupportPowder}`,
      borderRadius: 3,
      padding: `${unit * 0.5}px ${unit * 0.5 + 2}px`,
    },
  });

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'classes'>, WithStyles<typeof styles> {
  variant?: 'default' | 'square';
}

const IconButtonComponent: React.FC<IconButtonProps> = ({ classes, variant, ...rest }) => (
  <MuiIconButton
    classes={{
      root: classnames({
        [classes.variantSquare]: variant === 'square',
      }),
    }}
    {...rest}
  />
);

export const IconButton = withStyles(styles, { name: 'LumaIconButton' })(IconButtonComponent);
